var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "18px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.17 2C13.7 2 14.21 2.21 14.59 2.59L19.41 7.42C19.79 7.79 20 8.3 20 8.83V20C20 21.1 19.1 22 18 22H5.99C4.89 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2H13.17ZM15.1945 14.5925L13.2945 16.4925C13.1073 16.6774 13.002 16.9295 13.002 17.1925C13.002 17.4556 13.1073 17.7077 13.2945 17.8925C13.6845 18.2825 14.3045 18.2825 14.6945 17.8925L17.2845 15.2925C17.6745 14.9025 17.6745 14.2725 17.2845 13.8825L14.6945 11.2925C14.3045 10.9025 13.6845 10.9025 13.2945 11.2925C13.1073 11.4774 13.002 11.7295 13.002 11.9925C13.002 12.2556 13.1073 12.5077 13.2945 12.6925L15.1945 14.5925ZM10.7075 12.6925L8.8075 14.5925L10.7075 16.4925C10.8946 16.6774 11 16.9295 11 17.1925C11 17.4556 10.8946 17.7076 10.7075 17.8925C10.3175 18.2825 9.6975 18.2825 9.3075 17.8925L6.7175 15.3025C6.3275 14.9125 6.3275 14.2825 6.7175 13.8925L9.3075 11.2925C9.6975 10.9025 10.3175 10.9025 10.7075 11.2925C10.8946 11.4774 11 11.7295 11 11.9925C11 12.2556 10.8946 12.5077 10.7075 12.6925ZM13 3.50001V8.00001C13 8.55001 13.45 9.00001 14 9.00001H18.5L13 3.50001Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.9e0d8dfe1b50185c4fb726cd6f1d4b81.svg";
export { ForwardRef as ReactComponent };